import { Component, forwardRef, Input, OnInit } from '@angular/core';

import { ProvidersService } from '../../../providers/providers.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-provider-multi-select',
  templateUrl: './provider-multi-select.component.html',
  styleUrls: ['./provider-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProviderMultiSelectComponent),
      multi: true
    }
  ]
})
export class ProviderMultiSelectComponent implements OnInit, ControlValueAccessor {
  @Input() emitOnlyId = false;
  isLoad = false;
  dropdownList =  [];
  selectedItems = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'providerid',
    textField: 'description',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    maxHeight: 100,
    closeDropDownOnSelection: false,
    enableCheckAll: true,
  };
  public propagateChange: any  = () => {};
  constructor( private providerService: ProvidersService) {
    this.providerService.getCompaniesAll(false)
      .subscribe(
        (res: any) => {
          this.dropdownList = this.mapingResp(res);
          this.isLoad = true;
        },
        error => {

        }
      );

  }

  ngOnInit() {

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {

  }

  writeValue(obj: any): void {
    if (obj) {
      // this.selectedItems = this.updateDD(obj);
      setTimeout(() => this.selectedItems = this.updateDD(obj), 500);
    }

  }

  updateDD(obj) {
    const varValue = [];

    obj.map((item) => {

      this.dropdownList.map(f => {
          if (item.providerid === f.providerid) {
            varValue.push(f);
          }
      });

    });
    return varValue;

  }

  mapingResp(resp) {
    const arrayResp = resp.map((item) => {
      return {providerid: item.companyid, description: item.description };
    });
    return arrayResp;
  }

  /**
   * Propagate según Tipo
   */
  emitByType() {
    if (this.emitOnlyId) {
      const arrayEmit = this.selectedItems.map((item) => {
        return {providerid: item.providerid, description: item.description};
      });
      this.propagateChange(arrayEmit);
    } else {
      this.propagateChange(this.selectedItems);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/multi-select-dropdown/provider-multi-select/provider-multi-select.component.ts